import { Trans, useTranslation } from "react-i18next";

const HomePage = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col h-full justify-center items-start gap-4 text-lg md:text-xl lg:text-2xl font-helveticaNeue ">
      <div className="text-left">
        <p>{t("homePage.helloWorld")}</p>
        <p className="mt-4">{t("homePage.shortPresentation")}</p>
        <p className="mt-4">
          <Trans
            i18nKey="homePage.currentActivity"
            components={{
              qiara: (
                <a
                  href="https://www.qiara.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-800 dark:text-blue-400 hover:underline"
                />
              ),
              // abaxos: (
              //   <a
              //     href="https://www.abaxos.com"
              //     target="_blank"
              //     rel="noopener noreferrer"
              //     className="text-blue-800 dark:text-blue-400 hover:underline"
              //   />
              // ),
            }}
          />
        </p>
        <p className="mt-4">{t("homePage.otherHobbies")}</p>
      </div>
    </div>
  );
};

export default HomePage;
